export function windowOpen(url: string) {
  setTimeout(() => window.open(url));
}

export function downloadFile(url: string, filename?: string) {
  setTimeout(() => {
    const a = document.createElement('a');
    a.download = filename || true as any;
    a.href = url;
    a.target = '_blank';
    a.click();
  });
}
